import { ISenderAccount } from 'types/senderAccounts/senderAccount.types';
import {
  CLEAR_SENDER_ACCOUNT_STATE,
  CREATE_SENDER_ACCOUNT_FAILURE,
  CREATE_SENDER_ACCOUNT_REQUEST,
  CREATE_SENDER_ACCOUNT_SUCCESS,
  DELETE_SENDER_ACCOUNT_FAILURE,
  DELETE_SENDER_ACCOUNT_REQUEST,
  DELETE_SENDER_ACCOUNT_SUCCESS,
  GET_SENDER_ACCOUNT_BY_ID_FAILURE,
  GET_SENDER_ACCOUNT_BY_ID_REQUEST,
  GET_SENDER_ACCOUNT_BY_ID_SUCCESS,
  GET_VERIFIED_SENDER_ACCOUNTS_REQUEST,
  GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS,
  GET_VERIFIED_SENDER_ACCOUNTS_FAILURE,
  SenderAccountActionTypes,
  UPDATE_SENDER_ACCOUNT_REQUEST,
  UPDATE_SENDER_ACCOUNT_SUCCESS,
  UPDATE_SENDER_ACCOUNT_FAILURE,
} from './senderAccounts.types';

export interface SenderAccountState {
  senderAccount: ISenderAccount | null;
  verifiedSenderAccounts: ISenderAccount[];
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: SenderAccountState = {
  senderAccount: null,
  verifiedSenderAccounts: [],
  loading: false,
  error: null,
  success: false,
};

const senderAccountsReducer = (
  state: SenderAccountState = initialState,
  action: SenderAccountActionTypes
): SenderAccountState => {
  switch (action.type) {
    case CREATE_SENDER_ACCOUNT_REQUEST:
    case UPDATE_SENDER_ACCOUNT_REQUEST:
      return { ...state, loading: true, success: false };
    case CREATE_SENDER_ACCOUNT_SUCCESS:
    case UPDATE_SENDER_ACCOUNT_SUCCESS:
      return { ...state, loading: false, success: true };
    case CREATE_SENDER_ACCOUNT_FAILURE:
    case UPDATE_SENDER_ACCOUNT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };
    case GET_SENDER_ACCOUNT_BY_ID_REQUEST:
      return { ...state, loading: true };
    case GET_SENDER_ACCOUNT_BY_ID_SUCCESS:
      return { ...state, senderAccount: action.payload, loading: false };
    case GET_SENDER_ACCOUNT_BY_ID_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case DELETE_SENDER_ACCOUNT_REQUEST:
      return { ...state, loading: true };
    case DELETE_SENDER_ACCOUNT_SUCCESS:
      return { ...state, loading: false };
    case DELETE_SENDER_ACCOUNT_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case CLEAR_SENDER_ACCOUNT_STATE:
      return { ...state, success: false, error: null };
    case GET_VERIFIED_SENDER_ACCOUNTS_REQUEST:
      return { ...state, loading: true };
    case GET_VERIFIED_SENDER_ACCOUNTS_SUCCESS:
      return {
        ...state,
        verifiedSenderAccounts: action.payload,
        loading: false,
      };
    case GET_VERIFIED_SENDER_ACCOUNTS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export default senderAccountsReducer;
